/* The homepage uses native image loading. Start the legacy loader only if needed. */
(function () {
  'use strict';

  if (!window.lazySizes) return;

  var config = window.lazySizes.cfg;
  var selector = '.' + config.lazyClass + ', .' + config.autosizesClass;

  function needsLegacyLoader(root) {
    return root.nodeType === 1 && root.matches(selector) ||
      root.querySelector && root.querySelector(selector);
  }

  function initialize() {
    if (needsLegacyLoader(document)) {
      window.lazySizes.init();
      return;
    }

    // App content and theme-editor sections can still introduce legacy images.
    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        if (mutations[i].type === 'attributes' && needsLegacyLoader(mutations[i].target)) {
          observer.disconnect();
          window.lazySizes.init();
          return;
        }
        var added = mutations[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          if (needsLegacyLoader(added[j])) {
            observer.disconnect();
            window.lazySizes.init();
            return;
          }
        }
      }
    });
    observer.observe(document.documentElement, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class']
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }
})();
